namespace TabAurous.Production {
    export namespace ReceiptAgainstWorkOrderService {
        export const baseUrl = 'Production/ReceiptAgainstWorkOrder';

        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ReceiptMaterialItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Production/ReceiptAgainstWorkOrder/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>ReceiptAgainstWorkOrderService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
